import { createSelector } from "reselect"
import { DateTime } from "luxon"

import { IAIModal, IMessage } from "."
import { GlobalState } from "../../store"

export const selectAIModalById = (
    state: GlobalState,
    id: string,
): IAIModal | null => state.aIModal.modals[id] ?? null

const selectMessagesById = (state: IAIModal): IMessage[] => state.messages ?? []

// we sort the messages in ascending order
// oldest first, newest last
export const selectSortedMessages = createSelector(
    [selectMessagesById],
    (messages) => {
        const fallbackDate = new Date().toISOString()

        return [...messages].sort((a, b) => {
            const aTimestamp = DateTime.fromISO(a.timestamp ?? fallbackDate)
            const bTimestamp = DateTime.fromISO(b.timestamp ?? fallbackDate)

            return aTimestamp < bTimestamp
                ? -1
                : aTimestamp > bTimestamp
                ? 1
                : 0
        })
    },
)

export const selectUserSentMessages = createSelector(
    [selectSortedMessages],
    (sortedMessages) => {
        return sortedMessages.filter((message) => message.isSentByUser)
    },
)

export const selectLastMessage = createSelector(
    [selectSortedMessages],
    (messages) => {
        return messages.length > 0 ? messages[messages.length - 1] : null
    },
)

export const selectLastUserMessage = createSelector(
    [selectUserSentMessages],
    (messages) => {
        return messages.length > 0 ? messages[messages.length - 1] : null
    },
)
